export default __webpack_public_path__ + "static/media/byui.d12aa560.png";